import { Component, Input, OnInit, inject } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { FloorplanEventType } from "@domain/project/floorplan/floorplan-event";
import { FloorplanSelectionMode, LocalizeFloorplanSelectionModePipe } from "@domain/project/floorplan/floorplan-state";
import { ProjectFloorplanService } from "@domain/project/project-floorplan.service";
import { FormDirective } from "@odx/angular/components/form-field";
import { ToggleButtonComponent, ToggleButtonGroupComponent } from "@odx/angular/components/toggle-button-group";
import { ProjectStateService } from "@project/project-state.service";

@Component({
  selector: "app-floorplan-toggle-selection-mode",
  imports: [
    ToggleButtonComponent,
    ToggleButtonGroupComponent,
    ReactiveFormsModule,
    FormDirective,
    LocalizeFloorplanSelectionModePipe,
  ],
  templateUrl: "./floorplan-toggle-selection-mode.component.html",
})
export class FloorplanToggleSelectionModeComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private projectStateService = inject(ProjectStateService);
  private projectFloorplanService = inject(ProjectFloorplanService);

  private isUpdatingFromEvent = false;

  @Input({ required: true }) set activeFloorplan(floorplan: Floorplan) {
    this.floorplan = floorplan;
  }

  selectionModeForm!: FormGroup;
  floorplan!: Floorplan;

  ngOnInit() {
    this.selectionModeForm = this.formBuilder.group({
      selectionMode: [this.floorplan.floorplanState.selectionMode],
    });

    this.selectionModeForm.valueChanges.subscribe((value) => {
      if (this.isUpdatingFromEvent) return;
      if (!this.selectionModeForm.valid || this.selectionModeForm.pristine) return;
      this.floorplan.floorplanState.selectionMode = value.selectionMode;
    });

    this.projectFloorplanService.floorplanEvents$.subscribe((event) => {
      if (event.type === FloorplanEventType.FLOORPLAN_SELECTION_MODE_UPDATED) {
        this.isUpdatingFromEvent = true;
        this.selectionModeForm.setValue({ selectionMode: this.floorplan.floorplanState.selectionMode }, { emitEvent: false });
        this.isUpdatingFromEvent = false;
      }
    });
  }

  protected readonly FloorplanSelectionMode = FloorplanSelectionMode;
}
